import { Dispatch, FC, useState, useCallback } from "react";
import { StopEventPropagation } from "../../../helper/ui/methods";

interface ReportContentSettingDialogProps {
  reveal: boolean;
  userInputColumnCount: number;
  setReportContentSettingDialogReveal: Dispatch<React.SetStateAction<boolean>>;
  setUserInputColumnCount: Dispatch<React.SetStateAction<number>>;
}

const ReportContentSettingDialog: FC<ReportContentSettingDialogProps> = ({
  reveal,
  userInputColumnCount,
  setReportContentSettingDialogReveal,
  setUserInputColumnCount,
}) => {
  const DEFAULT_COLUMN_COUNT = 2;
  const [userInput, setUserInput] = useState<number | undefined>(
    userInputColumnCount
  );

  const HandleCancelClick = useCallback(() => {
    setUserInput(userInputColumnCount);
    setReportContentSettingDialogReveal(false);
  }, [userInput, setReportContentSettingDialogReveal]);

  const HandleApplyClick = useCallback(() => {
    if (userInput) {
      setUserInputColumnCount(userInput);
    } else {
      setUserInputColumnCount(DEFAULT_COLUMN_COUNT);
      setUserInput(DEFAULT_COLUMN_COUNT);
    }
    setReportContentSettingDialogReveal(false);
  }, [userInput]);

  if (!reveal) {
    return null;
  }

  return (
    <div className="dialogCover" onDoubleClick={StopEventPropagation}>
      <div className="dialog">
        <h2 className="dialogTitle">REPORT CONTENT SETTING</h2>
        <div className="dialogValueWrapper">
          <span className="dialogInputLabel">Column Count:</span>
          <input
            type="text"
            name="columnCount"
            value={userInput}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*$/.test(value)) {
                setUserInput(value ? parseInt(value, 10) : undefined);
              }
            }}
          />
        </div>
        <div className="dialogButtonWrapper">
          <input
            type="button"
            name="cancel"
            value="Cancel"
            onClick={HandleCancelClick}
          />
          <input
            type="button"
            name="apply"
            value="Apply"
            onClick={HandleApplyClick}
          />
        </div>
      </div>
    </div>
  );
};

export default ReportContentSettingDialog;
